import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button, Row } from "react-bootstrap";
import "../../components/button/button.css";
import "./missing.css";

const Missing = () => {
  const navigate = useNavigate();

  return (
    <>
      <Container
        fluid
        className="vh-100 d-flex flex-column"
        style={{ minHeight: "100vh" }}
      >
        <Row
          style={{ height: "33%" }}
          className="d-flex justify-content-center  align-items-center "
        >
          <div>
            <div className="text-center" style={{ color: "#00867F" }}>
              <p className="display-1">
                <b>?</b>
              </p>
              <p className="display-1">
                <b>若機器號碼遺失</b>
              </p>
            </div>
          </div>
        </Row>
        <Row style={{ height: "33%" }} className=" ">
          <ul style={{ width: `80%`, margin: "10% auto" }}>
            <li>
              <p className="h2">
                <b>
                  直接於官方LINE留言傳您的【診所名稱、聯繫電話、聯絡人、機器名稱、機器外觀照片】
                </b>
              </p>
            </li>
            <br></br>
            <li>
              <p className="h2">
                <b>
                  待客服人員確認完成後，約
                  <b className="text-danger">7日工作天</b>
                  內寄送新號碼單至您註冊的地址
                </b>
              </p>
            </li>
          </ul>
        </Row>
      
          <Button
            className=" btn-custom-green missing-button"
            onClick={() => {
              if (window.history.length <= 1) navigate("/main");
              else navigate(-1);
            }}
          >
            確認
          </Button>
          
      </Container>
    </>
  );
};

export default Missing;
